import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from '../../components/Iconify';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

export default function ScoutArchiveDialogButton({ profile, selectNextCrew }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [reason, setReason] = useState("");
  const [nextCrew, setNextCrew] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const stopPropagationForTab = (e) => {
    if (e.key === "Tab") {
      e.stopPropagation();
    }
  };

  const closeAndReload = () => {
    setOpen(false);
    selectNextCrew(nextCrew);
  };

  useEffect(() => {
    if (open) {
      setReason("");
      setNextCrew(null);
      setSent(false);
    }
  }, [open]);

  const decline = async () => {
    try {
      setLoading(true);
      const companyId = user?.employee.company?.[0]?.id;
      if (!profile?.id || !companyId) {
        enqueueSnackbar("요청이 실패하였습니다. 관리자에 문의해주세요.", { variant: 'warning' });
        return ;
      }
      const response = await axios.post(`/api/company/${companyId}/scout/${profile?.id}/decline/`, { reason });
      setNextCrew(response.data.next_crew);
      setSent(true);
      setLoading(false);
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 400 && error.response.data && error.response.data.message) {
        enqueueSnackbar(error.response.data.message, { variant: 'warning' });
      } else {
        enqueueSnackbar("요청이 실패하였습니다. 관리자에 문의해주세요.", { variant: 'warning' });
      }
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingButton
        sx={{
          color: "text.secondary", borderColor: "text.secondary"
        }}
        size={smUp ? "medium" : "small"}
        onClick={() => setOpen(true)}
        fullWidth
        variant="outlined"
        disableRipple
        startIcon={<Iconify icon="eva:close-fill" sx={{ width: 20, height: 20 }} />}
      >
        인재풀에 추가 안함
      </LoadingButton>
      <Dialog
        open={open}
        fullWidth
        maxWidth="dg"
        onKeyDown={stopPropagationForTab}
      >
        {sent ? (
        <DialogContent sx={{ p: { xs: 3, sm: 4 }, pb: "0!important" }}>
          <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
          <Typography variant="h5" gutterBottom>
            {profile?.nickname} 크루에 대한 피드백이 제출되었습니다. 
          </Typography>
          <Typography sx={{ mb: 3 }}>
            인재풀에 저장한 크루에게 커피챗 제안을 보내보세요.
          </Typography>
        </DialogContent>
        ) : (
        <DialogContent sx={{ p: { xs: 3, sm: 4 }, pb: "0!important" }}>
          <Typography variant="h5" gutterBottom>
            이 크루를 인재풀에 추가하지 않는 이유를 알려주세요.
          </Typography>
          <Typography variant="body2" sx={{ mb: 3 }}>
            다음 추천에 반영하겠습니다.<br/>인재풀에서 제외된 크루 내역은 스카우트 첫 화면에서 확인하실 수 있습니다.
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        )}
        {sent ? (
        <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
          <LoadingButton
            fullWidth={!smUp}
            variant="contained"
            size="large"
            sx={{ px: 4 }}
            onClick={closeAndReload}
            loading={loading}
          >
            확인했어요
          </LoadingButton>
        </DialogActions>
        ) : (
        <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
          <LoadingButton
            size="large"
            sx={{ px: 4 }}
            onClick={() => setOpen(false)}
            loading={loading}
          >
            취소
          </LoadingButton>
          <LoadingButton
            variant="contained"
            size="large"
            sx={{ px: 4 }}
            onClick={() => decline()}
            loading={loading}
            disabled={!reason}
          >
            제출하기
          </LoadingButton>
        </DialogActions>
        )}
      </Dialog>
    </>
  )
};
